import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm01 from "../data/form01.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true
};
const Form01: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave01, setInputValueFormLeave01] = useState({
    information: {
      reason: "",
      delegator: "",
      delegator_phone: "",
      address: "",
      province: "",
      district: "",
      district_sub: "",
      postcode: "",
      during_leave_phone: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave01.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave01]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave01({
        information: data.condition,
      });
    }
  }, []); // Empty dependency array to ensure it runs only once

  return (
    <FormComponent
      formGenerate={generateForm01}
      inputValue={inputValueFormLeave01}
      setInputValue={setInputValueFormLeave01}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form01;
